import RenderLoader from './RenderLoader';

export default RenderLoader;
